interface InsuranceBannerProps {
  className?: string;
}

export default function InsuranceBanner({ className = '' }: InsuranceBannerProps) {
  return (
    <div className={`my-6 ${className}`}>
      <div className="rounded-xl border border-[#E8DDD0] bg-[#FDFAF7] p-4">
        <p className="text-[10px] text-[#A0A0A0] font-medium mb-2 tracking-wide">PR・広告</p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <div className="flex-shrink-0">
            <a
              href="https://px.a8.net/svt/ejp?a8mat=4AZSSS+1E0FLE+2PS+2BF9A9"
              rel="nofollow noopener noreferrer"
              target="_blank"
              className="block"
              aria-label="火災保険の比較サービス"
            >
              <img
                border={0}
                width={234}
                height={60}
                alt="火災保険の比較サービス"
                src="https://www29.a8.net/svt/bgt?aid=260331148084&wid=001&eno=01&mid=s00000000352014012000&mc=1"
                loading="lazy"
                decoding="async"
                className="rounded-md"
              />
            </a>
            <img
              border={0}
              width={1}
              height={1}
              src="https://www14.a8.net/0.gif?a8mat=4AZSSS+1E0FLE+2PS+2BF9A9"
              alt=""
              className="absolute"
              style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden' }}
            />
          </div>
          <div className="text-center sm:text-left">
            <p className="text-xs font-bold text-[#2C2C2C] leading-snug mb-0.5">
              火災保険を比較して賢く選ぼう
            </p>
            <p className="text-[11px] text-[#6B6B6B] leading-relaxed">
              複数社を一括比較。家づくりと同時に検討がおすすめです。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
